import { gql } from '@apollo/client';

export const GET_TRANSPORTATIONS = gql`
    query GetTransportations {
        transportations {
            id
            name
            type
            seats
            color
        }
    }
`;
